<ng-container *ngIf="show">
  <div *ngIf="mode === 'inline'" class="ls-inline" role="status" [ngStyle]="hostStyles">
    <p-progressSpinner [style]="{ width: resolvedSize, height: resolvedSize }" strokeWidth="8" animationDuration="0.9s"></p-progressSpinner>
  </div>

  <div *ngIf="mode === 'overlay'" class="ls-overlay" [class.ls-overlay--with-backdrop]="backdrop" role="status" [ngStyle]="hostStyles">
    <p-progressSpinner [style]="{ width: resolvedSize, height: resolvedSize }" strokeWidth="8" animationDuration="0.9s"></p-progressSpinner>
  </div>
</ng-container>
